// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/@rsbuild/core/compiled/css-loader/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/@rsbuild/core/compiled/css-loader/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.dVpq1RMZQqgGN5uqATb_{align-items:center;display:flex}.THC8YfWqhoIRc0gv29Ff{margin-right:4px}.THC8YfWqhoIRc0gv29Ff>div{color:var(--content-primary-primary-inverted)}.dUsXNU2cNZoont59MW2x{color:var(--content-primary-primary-inverted);font-size:13px;font-weight:400}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"wrap": `dVpq1RMZQqgGN5uqATb_`,
	"wrapIcon": `THC8YfWqhoIRc0gv29Ff`,
	"label": `dUsXNU2cNZoont59MW2x`
};
export default ___CSS_LOADER_EXPORT___;
